import { Injectable } from '@angular/core';
import { format } from 'date-fns';

@Injectable({
  providedIn: 'root'
})
export class DateCommonService {

  getWorkingDayWithWeekendAndHoliday(date: Date,
    addDay: number,
    holidays: Array<any> = null,
    hasCheckCurrentDate = true): Date {
    let tmpDate = date;

    if (hasCheckCurrentDate) {
      while (this.isWeekend(tmpDate) || this.isHoliday(tmpDate, holidays)) {
        tmpDate = this.addDays(tmpDate, 1);
      }
    }

    while (addDay > 0) {
      tmpDate = this.addDays(tmpDate, 1);
      if (this.isWorkingDayInWeek(tmpDate) && !this.isHoliday(tmpDate, holidays)) {
        addDay--;
      }
    }
    return tmpDate;
  }

  getWorkingDayWithWeekendAndHolidayPre(date: Date,
    subDay: number,
    holidays: Array<any> = null,
    hasCheckCurrentDate = true): Date {
    let tmpDate = date;

    if (hasCheckCurrentDate) {
      while (this.isWeekend(tmpDate) || this.isHoliday(tmpDate, holidays)) {
        tmpDate = this.addDays(tmpDate, -1);
      }
    }
    while (subDay < 0) {
      tmpDate = this.addDays(tmpDate, -1);
      if (this.isWorkingDayInWeek(tmpDate) && !this.isHoliday(tmpDate, holidays)) {
        subDay++;
      }
    }
    return tmpDate;
  }

  getWorkingDayWithWeekend(date: Date, addDay: number, hasCheckCurrentDate = true): Date {
    return this.getWorkingDayWithWeekendAndHoliday(date, addDay, null, hasCheckCurrentDate);
  }

  addDays(startDate, day): Date {
    const returnDate = new Date(
      startDate.getFullYear(),
      startDate.getMonth(),
      startDate.getDate() + day);
    return returnDate;
  }

  isWeekend(date: Date): boolean {
    return date.getDay() === 0 || date.getDay() === 6;
  }

  isWorkingDayInWeek(date: Date): boolean {
    return !this.isWeekend(date);
  }

  isHoliday(date: Date, holidays: Array<any> = null): boolean {
    if (holidays && holidays.length > 0) {
      const length = holidays.length;
      for (let i = 0; i < length; i++) {
        const eventDate = format(holidays[i]['eventDate'], 'YYYYMMDD');
        const dateStr = format(date, 'YYYYMMDD');
        if (eventDate === dateStr) {
          return true;
        }
      }
    }
    return false;
  }

  dateFilter(date: Date, holidays: Array<any> = null): boolean {
    if (this.isWeekend(date)) {
      return false;
    }
    return !this.isHoliday(date, holidays);
  }
}
